import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-15c59688")

_pushScopeId("data-v-15c59688")
const _hoisted_1 = {
  class: "justify-center items-center max-w-xl mt-6 m-4 lg:w-3/5 sm:m-auto",
  style: {"font-family":"Nunito"}
}
const _hoisted_2 = { class: "z-0 text-3xl bold text-bp-dark bg-gray-70 text-center p-5 pb-0" }
const _hoisted_3 = { class: "text-center text-lg text-gray-700" }
const _hoisted_4 = { class: "flex  w-auto m-auto items-center justify-center" }
const _hoisted_5 = { class: "py-1 relative min-w-full" }
const _hoisted_6 = { class: "h-2 bg-gray-200 dark:bg-gray-500 rounded-full" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "absolute h-2 rounded-full bg-teal-600 w-0",
  style: {"width":"58.5714%"}
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "absolute h-4 flex items-center justify-center w-4 rounded-full bg-bp shadow  -ml-2 top-0 cursor-pointer",
  onselectstart: "return false;",
  style: {"left":"58.5714%"},
  unselectable: "on"
}, [
  /*#__PURE__*/_createVNode("div", { class: "relative -mt-2 w-1" }, [
    /*#__PURE__*/_createVNode("div", {
      class: "absolute z-40 opacity-100 bottom-100 mb-2 left-0 min-w-full",
      style: {"margin-left":"-20.5px"}
    })
  ])
], -1)
const _hoisted_9 = { class: "absolute text-gray-800 dark:text-gray-400 -ml-1 bottom-0 left-0 -mb-6" }
const _hoisted_10 = { class: "absolute text-gray-800 dark:text-gray-400 -mr-1 bottom-0 right-0 -mb-6" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", {
  class: "-mx-6",
  style: {"height":"6rem"}
}, [
  /*#__PURE__*/_createVNode("svg", {
    height: "401.888",
    preserveAspectRatio: "none",
    style: {"margin-top":"-70px"},
    viewBox: "0 0 1923.678 801.888",
    width: "auto",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [
    /*#__PURE__*/_createVNode("defs", null, [
      /*#__PURE__*/_createVNode("linearGradient", {
        id: "a",
        gradientUnits: "objectBoundingBox",
        x1: "0.5",
        x2: "0.5",
        y2: "1"
      }, [
        /*#__PURE__*/_createVNode("stop", {
          offset: "0",
          "stop-color": "#ff9c14"
        }),
        /*#__PURE__*/_createVNode("stop", {
          offset: "1",
          "stop-color": "#ff7500"
        })
      ])
    ]),
    /*#__PURE__*/_createVNode("path", {
      d: "M2839.753,664,916.367,666.141V386.716s61.437,51.619,356.926,56.929c150.726,2.708,451.693-36.314,\n        571.466-65.487,177.64-43.268,404.448-44.36,563.1-41.593,253.676,4.425,431.891,49.558,431.891,49.558Z",
      transform: "translate(-916.209 -335.668)",
      fill: "url(#a)"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M2839.934,979.271s-8.535,8.488-226.7-31.771-377.979-35.09-677.376,79.025-503.009,118.437-696.412,\n        106.519-323.185-90.817-323.185-90.817v-481.3s61.062,84.03,356.551,94.454c150.726,5.316,452.362-53.7,\n        572.135-110.97,177.64-84.934,404.448-87.078,563.1-81.646,253.675,8.686,431.889,97.281,431.889,97.281Z",
      transform: "translate(-916.256 -335.668)",
      fill: "url(#a)"
    })
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_input_nick_mail = _resolveComponent("input-nick-mail")
  const _component_DefaultButton = _resolveComponent("DefaultButton")
  const _component_input_password = _resolveComponent("input-password")
  const _component_DefaultCardLayout = _resolveComponent("DefaultCardLayout")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DefaultCardLayout, null, {
      default: _withId(() => [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("auth.ResetPasswordComponent.newPasswordTitle")), 1),
        _withDirectives(_createVNode("form", {
          class: "space-y-5 mt-5",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendResetPasswordLink && _ctx.sendResetPasswordLink(...args)), ["prevent"]))
        }, [
          _createVNode(_component_input_nick_mail, {
            email: _ctx.user.email,
            "onUpdate:email": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.email = $event))
          }, null, 8, ["email"]),
          _createVNode(_component_DefaultButton, {
            "button-text": _ctx.$t('auth.ResetPasswordComponent.newPasswordBtnConfirm'),
            "button-type": "submit",
            "button-width": "w-auto"
          }, null, 8, ["button-text"])
        ], 544), [
          [_vShow, _ctx.hasValidToken !== true]
        ]),
        _withDirectives(_createVNode("form", {
          class: "space-y-5 mt-5",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"]))
        }, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("auth.ResetPasswordComponent.newPasswordInput")), 1),
          _createVNode(_component_input_password),
          _createVNode(_component_input_password),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("auth.ResetPasswordComponent.newPasswordWeak")), 1),
                _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("auth.ResetPasswordComponent.newPasswordStrong")), 1)
              ])
            ])
          ]),
          _createVNode(_component_DefaultButton, {
            "button-text": _ctx.$t('auth.ResetPasswordComponent.newPasswordBtnConfirm'),
            "button-type": "submit",
            "button-width": "w-auto"
          }, null, 8, ["button-text"])
        ], 544), [
          [_vShow, _ctx.hasValidToken === true]
        ]),
        _hoisted_11
      ]),
      _: 1
    })
  ]))
})